import {WalletTransferStepAccount} from '#/components/wallet-transfer/wallet-transfer-step-account';
import {WalletTransferStepNative} from '#/components/wallet-transfer/wallet-transfer-step-native';
import {WalletTransferStepShareland} from '#/components/wallet-transfer/wallet-transfer-step-shareland';
import {WalletTransferStepStable} from '#/components/wallet-transfer/wallet-transfer-step-stable';
import {WalletTransferTab} from '#/components/wallet-transfer/wallet-transfer-tab';
import {ClassName} from '#/utils/utils';
import * as Tabs from '@radix-ui/react-tabs';
import {FunctionComponent} from 'react';

const TabsContent = ({children, className, ...rest}) => (
  <Tabs.Content className={`data-[state=active]:h-full flex flex-col ${className}`} {...(rest as any)}>
    {children}
  </Tabs.Content>
);
export const WalletTransferTabsContent: FunctionComponent<ClassName> = ({className}) => (
  <div className={className}>
    <TabsContent value={WalletTransferTab.ACCOUNT} {...({} as any)}>
      <WalletTransferStepAccount />
    </TabsContent>

    <TabsContent value={WalletTransferTab.SHARELAND} {...({} as any)}>
      <WalletTransferStepShareland />
    </TabsContent>

    <TabsContent value={WalletTransferTab.STABLE} {...({} as any)}>
      <WalletTransferStepStable />
    </TabsContent>

    <TabsContent value={WalletTransferTab.NATIVE} {...({} as any)}>
      <WalletTransferStepNative />
    </TabsContent>
  </div>
);
